<template>
  <!-- 资质列表 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        props
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <el-table
            border
            :data="extTable"
            class="ccui-form-child-table"
            max-height="99999"
          >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            fixed>
          </el-table-column>
          <el-table-column prop="remark" label="专业资质" width="220px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.subjectName`"
                :rules="tableRules.subjectName"
              >
                <el-input
                  readonly
                  @click.native="getScope(scope)"
                  style="width: 200px"
                  v-model="scope.row.subjectName"
                  placeholder="请选择"
                  clearable
                  maxlength="255"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="资质等级" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.gradeName`"
                :rules="tableRules.gradeName"
              >
                <el-select
                  style="width: 130px"
                  v-model="scope.row.gradeName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in qualificationLevel"
                    :key="item.dicKey"
                    :label="item.dicValue"
                    :value="item.dicValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="有效期开始" width="170px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.vaildStart`"
                  :rules="tableRules.vaildStart"
                >
                  <el-date-picker
                    v-model="scope.row.vaildStart"
                    type="date"
                    style="width: 150px"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="有效期结束" width="170px">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.vaildEnd`"
                  :rules="tableRules.vaildEnd"
                >
                  <el-date-picker
                    v-model="scope.row.vaildEnd"
                    type="date"
                    style="width: 150px"
                    placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions1"
                  >
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
          <el-table-column prop="formType" label="证书编号" width="200px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.qualificationCode`"
                :rules="tableRules.qualificationCode"
              >
                <el-input
                  style="width: 180px"
                  v-model="scope.row.qualificationCode"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                />
              </el-form-item>
            </template>
          </el-table-column>
            <el-table-column
              prop="titleName"
              label="发证机关"
              width="250px"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`extTable.${scope.$index}.attribute2`"
                  :rules="tableRules.attribute2"
                >
                  <el-input
                    style="width: 230px"
                    v-model="scope.row.attribute2"
                    placeholder="请输入"
                    clearable
                    maxlength="200"
                  />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <span
                  style="color: red; cursor: pointer"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加资质</div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="选择资质类型"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <qualificationType
        :treeData="qualificationType"
        @getnode="getnode"
        ref="msgFormSon"
      ></qualificationType>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBuildingGradeDict } from "@/api/subcontractor-register";
import qualificationType from "./qualificationTypeSelection.vue";
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },
  components: {
    qualificationType
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: function(time) {
          return false;
        }
      };
    },
    pickerOptions1() {
      return {
        disabledDate: function(time) {
          return time.getTime()<Date.now() - 8.64e7
        }
      };
    }
  },
  data() {
    return {
      checkOut:false,
      currentId: "",
      oneName: "",
      nodeName: "",
      centerDialogVisible: false,
      qualificationType: [],
      qualificationLevel: [],
      tableRules: {
        subjectName: [
          { required: true, message: "请选择专业", trigger: "change" }
        ],
        gradeName: [
          { required: true, message: "请选择等级", trigger: "change" }
        ],
        vaildStart: [{ required: true, message: "请选择有效期开始", trigger: "change" }],
        vaildEnd: [{ required: true, message: "请选择有效期结束", trigger: "change" }],
        qualificationCode: [{ required: true, message: "请输入证书编号", trigger: "blur" }],
        attribute2: [{ required: true, message: "请输入发证机关", trigger: "blur" }],
      },
      vaildTime: "",
      levelName: {
        a: [
          "通信工程施工总承包",
          "机电工程施工总承包",
          "地基基础工程专业承包",
          "起重设备安装工程专业承包",
          "桥梁工程专业承包",
          "隧道工程专业承包",
          "钢结构工程专业承包",
          "建筑机电安装工程专业承包",
          "古建筑工程专业承包",
          "城市及道路照明工程专业承包",
          "公路路面工程专业承包",
          "公路路基工程专业承包",
          "铁路电务工程专业承包",
          "铁路电气化工程专业承包",
          "港口与海岸工程专业承包",
          "航道工程专业承包",
          "通航建筑物工程专业承包",
          "水工金属结构制作与安装工程专业承包",
          "水利水电机电安装工程专业承包",
          "河湖整治工程专业承包",
          "输变电工程专业承包",
          "环保工程专业承包"
        ],
        b: [
          "电子与智能化工程专业承包",
          "消防设施工程专业承包",
          "防水防腐保温工程专业承包",
          "建筑装修装饰工程专业承包",
          "建筑幕墙工程专业承包",
          "机场场道工程专业承包",
          "民航空管工程及机场弱电系统工程专业承包",
          "机场目视助航工程专业承包",
          "港航设备安装及水上交管工程专业承包",
          "核工程专业承包",
          "海洋石油工程专业承包",
          "铁路铺轨架梁工程专业承包",
          "公路交通工程公路安全设施专业承包",
          "公路交通工程公路机电工程专业承包"
        ],
        c: [
          "预拌混凝土专业承包",
          "模板脚手架专业承包",
          "特种工程专业承包",
          "施工劳务",
          // "爆破工程分包",
          // "无资质",
          "其他"
        ],
        d: [
          "建筑工程施工总承包",
          "公路工程施工总承包",
          "铁路工程施工总承包",
          "港口与航道工程施工总承包",
          "水利水电工程施工总承包",
          "电力工程施工总承包",
          "矿山工程施工总承包",
          "冶金工程施工总承包",
          "石油化工工程施工总承包",
          "市政公用工程施工总承包"
        ]
      }
    };
  },
  mounted() {
    getBuildingGradeDict({}).then(res => {
      if (res.data.code === "0") {
        this.qualificationLevel = res.data.data;
      }
    });
  },
  methods: {
    getScope(scope) {
      this.currentId = scope.$index;
      this.centerDialogVisible = true;
    },
    getnode(name, oneName) {
      this.nodeName = name;
      this.oneName = oneName;
    },
    getTreeItem() {
      if (!this.nodeName) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请点击选择二级节点数据",
          ccuiCustom: true
        });
        return false;
      } else {
          if (this.levelName.a.indexOf(this.nodeName) >= 0) {
            this.$set(
              this.extTable[this.currentId],
              "qualificationLevel",
              [
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "3",
                  dicValue: "一级资质标准"
                },
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "4",
                  dicValue: "二级资质标准"
                },
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "5",
                  dicValue: "三级资质标准"
                }
              ]
            );
          }
          if (this.levelName.d.indexOf(this.nodeName) >= 0) {
            this.$set(
              this.extTable[this.currentId],
              "qualificationLevel",
              [
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "3",
                  dicValue: "一级资质标准"
                },
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "4",
                  dicValue: "二级资质标准"
                },
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "5",
                  dicValue: "三级资质标准"
                },
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "6",
                  dicValue: "特级"
                }
              ]
            );
          }
          if (this.levelName.b.indexOf(this.nodeName) >= 0) {
            this.$set(
              this.extTable[this.currentId],
              "qualificationLevel",
              [
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "3",
                  dicValue: "一级资质标准"
                },
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "4",
                  dicValue: "二级资质标准"
                }
              ]
            );
          }
          if (this.levelName.c.indexOf(this.nodeName) >= 0) {
            this.$set(
              this.extTable[this.currentId],
              "qualificationLevel",
              [
                {
                  categoryCode: "BUILDING_GRADE",
                  dicKey: "1",
                  dicValue: "不分等级"
                }
              ]
            );
          }
          this.$set(
            this.extTable[this.currentId],
            "gradeName",
            ""
          );
        this.$set(this.extTable[this.currentId], "subjectName", this.nodeName);
        this.$set(
          this.extTable[this.currentId],
          "qualificationName",
          this.nodeName
        );
        this.$set(
          this.extTable[this.currentId],
          "attribute3",
          this.oneName
        );
        this.centerDialogVisible = false;
      }
    },
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1
        });
      }
    },
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
    changePicker(date, row, scope) {
      if (this.extTable && this.extTable.length > 0) {
        this.extTable[scope.$index].vaildStart = this.getDate(date[0]);
        this.extTable[scope.$index].vaildEnd = this.getDate(date[1]);
      }
    },
    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let time = y + "-" + m + "-" + d;
      return time;
    },
    lastStep() {
      this.$emit("getStep", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  // padding-right: 25px;
}
/deep/ .el-input__suffix {
  // right: 0px;
  .el-input__clear {
    width: 23px;
  }
}
.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }

   th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(8)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
}
</style>
